import React, { Component } from 'react';
import { FORMAT_NUMBER, SERVICE_API, CURRENCY, BASE_URL } from '../libs/utils/Const';
import { decodeText } from '../libs/utils/Const';

class SearchStockModal extends Component {
    componentWillUnmount() {
        const { cleanData } = this.props;
        cleanData();
    }

    render() {
        const {  suggestions, cleanData } = this.props;
        return (
            <div className="modal fade" id="searchStockModal" data-keyboard="false" tabIndex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h4 style={{color: 'white'}}>{suggestions && suggestions.length > 0 && suggestions[0].ItemCode ? suggestions[0].ItemCode : ''}</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={cleanData}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive scrollSearchs">
                                <table className="table">
                                    <thead className='sticky-headerPOS'>
                                        <tr>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="p-2 px-3 text-uppercase">Artículo</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="p-2 px-3 text-uppercase">Descripción</div>
                                            </th>
                                            <th scope="col" colspan={2} className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Almacén</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Existencias</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Precio promedio</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!!suggestions &&
                                            suggestions.map((item, index) => {
                                                return (
                                                    <tr key={`SearchItemId${index}`}>
                                                        <td className="align-middle">{`${item.ItemCode ?? ''}`}</td>
                                                        <td className="align-middle">{decodeText(item.ItemName ?? '')}</td>

                                                        <td className="align-middle">{`${item.WhsCode ?? ''}`}</td>
                                                        <td className="align-middle">{decodeText(item.WhsName ?? '')}</td>
                                                        
                                                        <td className="align-middle">{`${FORMAT_NUMBER.new(item.OnHand ?? 0)}`}</td>
                                                        <td className="align-middle"><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(item.AvgPrice)}</strong></td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>




                        </div>
                        <div className="modal-footer">

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchStockModal;